export const getters = () => {
  return {
    // page navigation
    currentPageNumber: state => state.calculatorData.currentPageNumber,
    currentPage: state => state.calculatorData.calculatorPages[state.calculatorData.currentPageNumber],
    disableNext: state => state.calculatorData.disableNext,
    allowStepUpTo: state => state.calculatorData.allowStepUpTo,
    calculatorPages: state => state.calculatorData.calculatorPages,
    tinyLink: state => state.calculatorData.tinyLink,
    base64Link: state => state.calculatorData.base64Link,
    pageError: (state) => (headline) => {
      const page = state.calculatorData.calculatorPages.find(calculatorPages => calculatorPages.headline === headline)
      return page ? page.errors : false
    },
    disabledPage: (state) => (headline) => {
      const page = state.calculatorData.calculatorPages.find(calculatorPages => calculatorPages.headline === headline)
      return page ? page.disabled : false
    },
    disabledStatusTab0: state => state.calculatorData.calculatorPages[0].disabled,
    disabledStatusTab1: state => state.calculatorData.calculatorPages[1].disabled,
    disabledStatusTab2: state => state.calculatorData.calculatorPages[2].disabled,
    disabledStatusTab3: state => state.calculatorData.calculatorPages[3].disabled,
    disabledStatusTab4: state => state.calculatorData.calculatorPages[4].disabled,
    disabledStatusTab5: state => state.calculatorData.calculatorPages[5].disabled,
    disabledStatusTab6: state => state.calculatorData.calculatorPages[6].disabled,
    disabledStatusTab7: state => state.calculatorData.calculatorPages[7].disabled,
    disabledStatusTab8: state => state.calculatorData.calculatorPages[8].disabled,

    // currentorder Values
    currentOrder: state => state.calculatorData.currentOrder,
    elementForm: state => state.calculatorData.currentOrder.elementForm,
    isBox: state => state.calculatorData.currentOrder.isBox,
    dripEdgeProfile: state => state.calculatorData.currentOrder.dripEdgeProfile,
    wallProfiles: state => state.calculatorData.currentOrder.wallProfiles,
    vacuumPanels: state => state.calculatorData.currentOrder.vacuumPanels,
    profilColor: state => state.calculatorData.currentOrder.profilColor,
    a: state => state.calculatorData.currentOrder.a,
    a1: state => state.calculatorData.currentOrder.a1,
    a2: state => state.calculatorData.currentOrder.a2,
    totalLength: state => state.calculatorData.currentOrder.totalLength,
    totalLengthOfOneElement: state => state.calculatorData.currentOrder.totalLengthOfOneElement,
    totalElements: state => state.calculatorData.currentOrder.totalElements,
    b: state => state.calculatorData.currentOrder.b,
    e: state => state.calculatorData.currentOrder.e,
    d1: state => state.calculatorData.currentOrder.d1,
    d2: state => state.calculatorData.currentOrder.d2,
    c: state => state.calculatorData.currentOrder.c,
    g: state => state.calculatorData.currentOrder.g,
    f: state => state.calculatorData.currentOrder.f,
    insulationMaterial: state => state.calculatorData.currentOrder.insulationMaterial,
    h: state => state.calculatorData.currentOrder.h,
    w: state => state.calculatorData.currentOrder.w,
    notches: state => state.calculatorData.currentOrder.notches,
    calculatorMin: state => {
      return {
        a: () => state.calculatorData.calculatorPages[2].inputFields[0].min,
        a1: () => state.calculatorData.calculatorPages[2].inputFields[1].min,
        a2: () => state.calculatorData.calculatorPages[2].inputFields[2].min,
        c: () => state.calculatorData.calculatorPages[3].inputFields[0].min,
        d1: () => state.calculatorData.calculatorPages[3].inputFields[1].min,
        d2: () => state.calculatorData.calculatorPages[3].inputFields[2].min,
        e: () => state.calculatorData.calculatorPages[4].inputFields[0].min,
        b: () => state.calculatorData.calculatorPages[4].inputFields[1].min,
        w: () => state.calculatorData.calculatorPages[4].inputFields[2].min,
        h: () => state.calculatorData.calculatorPages[4].inputFields[3].min,
        g: () => state.calculatorData.calculatorPages[6].inputFields[2].min,
        f: () => state.calculatorData.calculatorPages[6].inputFields[1].min
      }
    },
    calculatorMax: state => {
      return {
        a: () => state.calculatorData.calculatorPages[2].inputFields[0].max,
        a1: () => state.calculatorData.calculatorPages[2].inputFields[1].max,
        a2: () => state.calculatorData.calculatorPages[2].inputFields[2].max,
        c: () => state.calculatorData.calculatorPages[3].inputFields[0].max,
        d1: () => state.calculatorData.calculatorPages[3].inputFields[1].max,
        d2: () => state.calculatorData.calculatorPages[3].inputFields[2].max,
        e: () => state.calculatorData.calculatorPages[4].inputFields[0].max,
        b: () => state.calculatorData.calculatorPages[4].inputFields[1].max,
        w: () => state.calculatorData.calculatorPages[4].inputFields[2].max,
        h: () => state.calculatorData.calculatorPages[4].inputFields[3].max,
        g: () => state.calculatorData.calculatorPages[6].inputFields[2].max,
        f: () => state.calculatorData.calculatorPages[6].inputFields[1].max
      }
    },
    calculatorSteps: state => {
      return {
        a: () => state.calculatorData.calculatorPages[2].inputFields[0].steps,
        a1: () => state.calculatorData.calculatorPages[2].inputFields[1].steps,
        a2: () => state.calculatorData.calculatorPages[2].inputFields[2].steps,
        c: () => state.calculatorData.calculatorPages[3].inputFields[0].steps,
        d1: () => state.calculatorData.calculatorPages[3].inputFields[1].steps,
        d2: () => state.calculatorData.calculatorPages[3].inputFields[2].steps,
        e: () => state.calculatorData.calculatorPages[4].inputFields[0].steps,
        b: () => state.calculatorData.calculatorPages[4].inputFields[1].steps,
        w: () => state.calculatorData.calculatorPages[4].inputFields[2].steps,
        h: () => state.calculatorData.calculatorPages[4].inputFields[3].steps,
        g: () => state.calculatorData.calculatorPages[6].inputFields[2].steps,
        f: () => state.calculatorData.calculatorPages[6].inputFields[1].steps
      }
    },
    calculatorDefault: state => {
      return {
        a: () => state.calculatorData.calculatorPages[2].inputFields[0].default,
        a1: () => state.calculatorData.calculatorPages[2].inputFields[1].default,
        a2: () => state.calculatorData.calculatorPages[2].inputFields[2].default,
        c: () => state.calculatorData.calculatorPages[3].inputFields[0].default,
        d1: () => state.calculatorData.calculatorPages[3].inputFields[1].default,
        d2: () => state.calculatorData.calculatorPages[3].inputFields[2].default,
        e: () => state.calculatorData.calculatorPages[4].inputFields[0].default,
        b: () => state.calculatorData.calculatorPages[4].inputFields[1].default,
        w: () => state.calculatorData.calculatorPages[4].inputFields[2].default,
        h: () => state.calculatorData.calculatorPages[4].inputFields[3].default,
        g: () => state.calculatorData.calculatorPages[6].inputFields[2].default,
        f: () => state.calculatorData.calculatorPages[6].inputFields[1].default
      }
    }
  }
}
